import React from 'react'

import Experiment from '@mc/experiments-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useStaticData } from '@mc/static-data-react'

import { PromoModalEmailCapture } from './EmailCapture'
import { EMAIL_CAPTURE_PROMO_MODAL } from './usePromoModalEmailCaptureExp'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

export const ModalEmailCaptureExp = ({
  ControlComp,
  pageSource,
}: {
  ControlComp: React.ComponentType
  pageSource: string
}) => {
  const { isLoggedIn } = useStaticData<{ isLoggedIn: boolean }>()
  if (isLoggedIn) {
    return <ControlComp />
  }

  return (
    <Experiment
      name={EMAIL_CAPTURE_PROMO_MODAL}
      control={ControlComp}
      variant_1={() => (
        <QueryClientProvider client={queryClient}>
          <PromoModalEmailCapture pageSource={pageSource} />
        </QueryClientProvider>
      )}
    />
  )
}
